import {
  Box,
  Table as MUITable,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import { FC } from "react";
import { TableProps } from "./table.types";

const Table: FC<TableProps> = ({
  count,
  page,
  headCells,
  bodyCells,
  rowsPerPage,
  rowsPerPageOptions,
  onPageChange,
  onRowsPerPageChange,
}) => {
  return (
    <Box sx={{ width: "100%" }}>
      <TableContainer>
        <MUITable size={"medium"}>
          <TableHead>
            <TableRow>
              {headCells.map((headCell, index) => (
                <TableCell key={index}>{headCell}</TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {bodyCells.map((row, index) => (
              <TableRow
                hover
                role="checkbox"
                tabIndex={-1}
                key={index}
                sx={{ cursor: "pointer" }}
              >
                {row.map((cell, index) => (
                  <TableCell key={index} align="left">
                    {cell}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </MUITable>
      </TableContainer>
      <TablePagination
        component="div"
        page={page}
        count={count}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={rowsPerPageOptions}
        onPageChange={(_, page) => onPageChange(page)}
        onRowsPerPageChange={onRowsPerPageChange}
      />
    </Box>
  );
};

export { Table };
